<script lang="ts">
  import Link from "svelte-link";
  import { Col, Form, Row } from "sveltestrap";
  import  {Shareit} from "../../../../utils/Constant/Constant"
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
</script>
<div class="pro-group">
  <Row>
    <Col md="4" class="xl-50">
      <h6 class="product-title">{Shareit}</h6>
    </Col>
    <Col md="7" class="xl-50">
      <div class="product-icon">
        <ul class="product-social">
          {#each data.shareitdata as shareItem }
            <li class="d-inline-block">
              <Link href={shareItem.link} target="_blank">
                <i class="fa {shareItem.icon}"></i>
              </Link>
            </li>
          {/each}
        </ul>
        <Form class="d-inline-block f-right"></Form>
      </div>
    </Col>
  </Row>
</div>